import defaultTheme from "./default";

const palette = { ...defaultTheme.palette };
palette.primary = "hsla(360, 73%, 54%, 1)";

const theme = { ...defaultTheme, palette };

export default theme;
